<template>
  <div :class="{ fcl: layout === 1, pip: layout === 0 }">
    <div :class="layoutClasses">
      <div class="screen-big" ref="mainVideo" :style="{ width: layout === 1 ? mainWith : '' }">
        <hstWhiteBoard v-if="shareData && shareData.mediaType === 'WHITE_BOARD'" :user="shareData"></hstWhiteBoard>
        <hstScreenShare
          v-else-if="shareData && shareData.mediaType === 'SCREEN_SHARE'"
          :user="shareData"
        ></hstScreenShare>
        <hstMediaShare v-else-if="shareData && shareData.mediaType === 'VIDEO'" :user="shareData"></hstMediaShare>
        <hst-audio-share v-if="shareData && shareData.mediaType === 'AUDIO'" :user="shareData" />
      </div>
    </div>
    <div class="bottom" :class="{ full_bottom: this.layoutScreenfull }">
      <div class="screen-wrapper">
        <div
          :class="{ 'video-big': index === 0 && !shareData.userId, 'screen-min': index !== 0 || shareData.userId }"
          :style="{ width: index === 0 && !shareData.userId ? (layout === 1 ? mainWith : '') : minWith }"
          v-for="(item, index) in leftVideos"
          :key="`${item.userId}_${item.mediaId}`"
        >
          <hstVideo
            :user="item"
            ref="video1"
            :isBig="index === 0 && !shareData.userId"
            :videoSize="videoSize"
          ></hstVideo>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// 视频路数3个以上才会出现这个焦点布局
import hstWhiteBoard from '@/components/hstMedia/hstWhiteBoard'
import hstMediaShare from '@/components/hstMedia/hstMediaShare'
import hstAudioShare from '@/components/hstMedia/hstAudioShare'
import hstScreenShare from '@/components/hstMedia/hstScreenShare'
import auidoIcon from '@/components/hstMedia/audioIcon'
import hstVideo from '@/components/hstMedia/hstVideo'
import { throttle } from '@/utils/util'
import { mapGetters } from 'vuex'
export default {
  props: {
    screenShare: {
      type: Array,
      default: () => []
    },
    whiteBoard: {
      type: Array,
      default: () => []
    },
    mediaShare: {
      type: Array,
      default: () => []
    },
    shareData: {
      type: Object,
      default: () => {}
    },
    videoDatas: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      videoList: [],
      focuName: '',
      minVideos: [],
      fullHeight: 800,
      fullWidth: 600,
      mainWith: '200px',
      minWith: '40px',
      videoSize: {
        leftBlack: false,
        videoWidth: 0,
        maxIconWidth: 200
      }
    }
  },
  computed: {
    ...mapGetters(['groupUserList', 'layoutScreenfull', 'browserScreenfull']),
    layout: function () {
      if (this.shareData.userId) {
        if (this.videoDatas.length > 1) {
          return 1 // 焦点
        } else {
          return 0 // 画中画
        }
      } else {
        if (this.videoDatas.length > 2) {
          return 1 // 画中画
        } else {
          return 0 // 焦点
        }
      }
    },
    layoutClasses () {
      return [
        this.layout === 1 ? 'top' : 'outer-big',
        {
          'full-screen': this.layoutScreenfull
        }
      ]
    },
    leftVideos: function () {
      // 计算剩余要显示的videos
      var sliceArr = []
      if (this.shareData.userId) {
        sliceArr = this.videoDatas.slice(0, 4)
      } else {
        sliceArr = this.videoDatas.slice(0, 5) // 最多显示4路小视频
      }
      return sliceArr
    },
    chatShow() {
      return this.$store.state.chat.chatShow
    }
  },
  watch: {
    // layoutScreenfull: function (val) {
    //   // 从全屏布局到焦点时，大窗口的宽度有变
    //   const topWidth = (this.fullHeight * 16) / 9
    //   const bottomWidth = (topWidth * 4) / 5
    //   if (val) {
    //     this.mainWith = this.layout === 1 ? topWidth + 'px' : '100%'
    //     this.videoSize.videoWidth = topWidth + 'px'
    //   } else {
    //     this.mainWith = this.videoSize.videoWidth = this.layout === 1 ? bottomWidth + 'px' : topWidth + 'px'
    //   }
    // },
    browserScreenfull: function (val) {
      // 浏览器全屏状态变化重新计算窗口大小
      this.calcVideoSize()
    },
    chatShow() {
      this.calcVideoSize()
    },
    videoDatas: {
      deep: true,
      handler (newVal, oldVal) {
        // 视频数量变化要重新计算下视频的宽高
        this.$nextTick(()=>{
          this.calcVideoSize()
        })
      }
    }
  },
  components: {
    auidoIcon,
    hstVideo,
    hstWhiteBoard,
    hstScreenShare,
    hstMediaShare,
    hstAudioShare
  },
  mounted () {
    this.calcVideoSize()
    window.onresize = throttle(() => {
      // 窗口缩放时，节流调整大小窗口的宽度
      // 退出全屏时，先执行了onresize,再执行了浏览器全屏变化,需要监听再计算
      this.calcVideoSize()
    }, 200)
  },
  methods: {
    calcVideoSize () {
      // 计算布局内视频的宽度
      const docHeight = document.documentElement.clientHeight // 浏览器显示区域高度
      const videoRatio = 1.7777777 // 16：9的比例
      this.fullHeight = this.browserScreenfull ? docHeight : docHeight - 90
      this.fullWidth = document.querySelector('.logined-meeting-content .left-part').offsetWidth
      const dataRatio = (this.fullWidth / this.fullHeight).toFixed(6) // 显示区域的比例

      const pipWidth = ((this.fullHeight * 16) / 9).toFixed(2) // 画中画时的视频宽度
      this.mainWith = (pipWidth * 4) / 5 + 'px' // 焦点时大视频的宽度
      this.minWith = pipWidth / 5 + 'px' // 焦点时小视频的宽度
      // 计算传递给显示视频组件的参数
      this.videoSize.maxIconWidth = pipWidth / 5 - 20 // 小窗口用户名的显示最大宽度
      this.videoSize.leftBlack = dataRatio >= videoRatio // 左右黑边还是上下黑边
      // 计算内部video的宽度
      this.videoSize.videoWidth =
        dataRatio >= videoRatio
          ? (this.videoSize.videoWidth = this.layout === 0 ? pipWidth + 'px' : (pipWidth * 4) / 5 + 'px')
          : '100%'
      if (this.layoutScreenfull) this.mainWith = this.videoSize.videoWidth = pipWidth + 'px' // 布局全屏时的宽度为画中画视频宽度
    }
  },
  beforeDestroy () {
    // 事件注销
    window.onresize = null
  }
}
</script>
<style lang="less" scoped>
.fcl {
  width: 100%;
  height: 100%;
  position: relative;
  .top {
    width: 100%;
    height: 80%;
    z-index: 1;
    .screen-big {
      margin: 0 auto;
      width: 80%;
      height: 100%;
      text-align: center;
      background: #454d5c;
      border: 1px solid #454d5c;
      position: relative;
    }
  }
  .bottom {
    width: 100%;
    height: 20%;
    .screen-min {
      width: 218px;
      height: 100%;
      text-align: center;
      background: #454d5c;
      border: 1px solid #454d5c;
      position: relative;
    }
    .screen-wrapper {
      margin: 0 auto;
      height: 100%;
      display: flex;
      flex-direction: row;
      justify-content: center;
    }
    .video-big {
      position: absolute;
      top: 0;
      height: 80%;
      width: 100%;
      z-index: 1;
      border: 1px solid #454d5c;
    }
  }
  .full-screen {
    .screen-big {
      height: 100%;
    }
  }
  .full_bottom {
    .video-big {
      height: 100%;
    }
    .screen-min {
      display: none;
    }
  }
}
.pip {
  width: 100%;
  height: 100%;
  position: relative;
  .outer-big {
    width: 100%;
    height: 100%;
    position: relative;
    text-align: center;
    z-index: 1;
    .screen-big {
      height: 100%;
      width: 100%;
    }
  }
  .screen-min {
    position: absolute;
    right: 20px;
    bottom: 20px;
    width: 384px;
    height: 20%;
    text-align: center;
    // background: #e3e7f1;
    border: 1px solid #ffffff;
    box-shadow: 0px 6px 16px 0px rgba(50, 55, 74, 0.5);
    z-index: 10;
  }
  .video-big {
    position: absolute;
    top: 0;
    width: 100%;
    height: 100%;
    z-index: 9;
  }
  .full_bottom .screen-min {
    display: none;
  }
}
.full-screen {
  width: 100% !important;
  height: 100% !important;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 100;
}
</style>
